<template>
	<apexchart 
		:width="width" 
		:height="height" 
		:options="chartOptions" 
		:series="series" 
	/>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	name: "PerformanceChart",
	components: {
		apexchart: VueApexCharts,
	},
	props: {
		width: {
			type: [Number, String],
			default: "100%",
		},
		height: {
			type: [Number, String],
			default: "90%",
		},
		data: {
			type: Number,
			default: 75
		}
	},
	data() {
		return {
			zones: [
				{ min: 0, max: 59.99, color: "#ef4444", label: "Crítico" },
				{ min: 60, max: 79.99, color: "#f59e0b", label: "Atenção" },
				{ min: 80, max: 100, color: "#10b981", label: "Ideal" }
			]
		};
	},
	computed: {
		currentZone() {
			return this.zones.find(zone => this.data >= zone.min && this.data <= zone.max);
		},
		barColor() {
			return this.currentZone?.color || "#6b7280";
		},
		series() {
			return [
				{
					name: "Nível de Serviço",
					data: [this.data],
				}
			];
		},
		chartOptions() {
			return {
				chart: {
					type: "bar",
					toolbar: { show: false },
				},
				title: {
					text: 'Nível de Serviço',
					align: "center",
					style: {
						fontSize: "16px",
						fontWeight: "bold",
						color: "#374151"
					},
				},
				subtitle: {
					text: `Status: ${this.currentZone?.label || 'N/A'}`,
					align: "center",
					style: {
						fontSize: "12px",
						color: this.barColor,
						fontWeight: "600"
					},
				},
				plotOptions: {
					bar: {
						horizontal: true,
						barHeight: "60%",
						distributed: true,
						borderRadius: 8,
					},
				},
				colors: [this.barColor],
				dataLabels: {
					enabled: true,
					style: {
						colors: ["#fff"],
						fontSize: "14px",
						fontWeight: "bold",
					},
					formatter: (val) => `${val}%`,
					offsetX: 10,
					dropShadow: {
						enabled: true,
						top: 1,
						left: 1,
						blur: 2,
						opacity: 0.8,
						color: "#000",
					},
				},
				xaxis: {
					show: false,
					tickAmount: 4,
					min: 0,
					max: 100,
					categories: ["Nível de Serviço"],
					axisBorder: { show: false },
					axisTicks: { show: false },
					labels: { show: false },
				},
				yaxis: {
					show: false,
				},
				grid: {
					show: false,
				},
				tooltip: {
					enabled: true,
					custom: ({ series, seriesIndex, dataPointIndex }) => {
						const value = series[seriesIndex][dataPointIndex];
						const zone = this.zones.find(z => value >= z.min && value <= z.max);
						return `
						  <div style="
						    padding: 10px; 
						    background: white; 
						    border-radius: 8px; 
						    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
						    max-width: 300px; 
						    white-space: normal; 
						    word-wrap: break-word;
						    font-size: 12px;
						    line-height: 1.4;
						  ">
						    <div style="font-weight: bold; color: ${zone?.color}; margin-bottom: 5px;">
						      ${zone?.label} (${zone?.min}-${zone?.max}%)
						    </div>
						    <div style="font-size: 11px; color: #6b7280; margin-top: 5px;">
						      ${value >= 80 ? '✓ Atendendo SLA 80/20' : '⚠ Abaixo do SLA esperado'}
						    </div>
						    <div style="margin-top: 5px; font-size: 10px; color: #4b5563; font-weight: bold">
						      ❓ O Nível de Serviço é a porcentagem de chamadas <br> 
							  atendidas em até 20 segundos sobre o total atendido
						    </div>
						  </div>
						`;
					}
				},
				legend: {
					show: false,
				},
				annotations: {
					xaxis: [
						{
							x: 60,
							strokeDashArray: 2,
							borderColor: '#f59e0b',
							label: {
								text: '60%',
								position: 'top',
								style: {
									color: '#f59e0b',
									background: '#FFF',
									fontSize: '11px',
									fontWeight: 600
								}
							}
						},
						{
							x: 80,
							strokeDashArray: 2,
							borderColor: '#10b981',
							label: {
								text: '80%',
								position: 'top',
								style: {
									color: '#10b981',
									background: '#FFF',
									fontSize: '11px',
									fontWeight: 600
								}
							}
						}
					],
					// Zonas de fundo (opcional - deixe comentado se preferir mais limpo)
					
					boxes: [
						{
							x: 0, x2: 60, y: 0, y2: 100,
							fillColor: '#ef4444',
							opacity: 0.1
						},
						{
							x: 60, x2: 80, y: 0, y2: 100,
							fillColor: '#f59e0b',
							opacity: 0.1
						},
						{
							x: 80, x2: 100, y: 0, y2: 100,
							fillColor: '#10b981',
							opacity: 0.1
						}
					]
					
				}
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.chart-container {
	padding: 0 10px;
}
</style>